/**
 * @author      autogenerated
 * @copyright   Copyright (c) 2025, Zumper
 * @description NeighborhoodType
 */

export enum NeighborhoodType {
  NEIGHBORHOOD = 1,
  ZIPCODE = 2,
  HONEYPOT = 3,
  REGION = 4,
}

Object.defineProperty(NeighborhoodType, '__ENUM_NAME', {
  value: 'NeighborhoodType',
  writable: false,
  configurable: false,
  enumerable: false,
})
